import React, { Component } from "react";
import { element, shape, string } from "prop-types";

class UserLink extends Component {
    static propTypes = {
        children: element,
        loggedUser: shape({
            userFullName: string.isRequired,
            email: string.isRequired,
        }).isRequired,
    };

    static defaultProps = {
        children: null,
    };

    render() {
        const {
            children,
            loggedUser: { userFullName, email },
        } = this.props;

        return (
            <section className="px-5">
                <p className="ellipsis bold m-0 mt-6">{userFullName}</p>
                <p className="ellipsis tiny-small mt-2 mb-6">{email}</p>
                {children}
            </section>
        );
    }
}

export default UserLink;
